<!-- eslint-disable -->
<template>
  <v-container class="register-container">
    <v-row justify="center" align="center" style="min-height: 80vh;">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card elevation="8" class="pa-8">
          <v-card-title class="text-h4 text-center mb-6">
            <v-icon size="large" color="primary" class="mr-2">mdi-account-group</v-icon>
            <div>{{ $t('auth.register') }}</div>
          </v-card-title>

          <v-card-subtitle class="text-center mb-6">
            {{ $t('home.cta.createProfile') }}
          </v-card-subtitle>

          <v-alert v-if="errorMessage" type="error" class="mb-4">
            {{ errorMessage }}
          </v-alert>

          <v-alert v-if="successMessage" type="success" class="mb-4">
            {{ successMessage }}
          </v-alert>

          <v-form @submit.prevent="handleRegister" ref="formRef">
            <v-text-field
              v-model="displayName"
              :label="$t('auth.name')"
              prepend-inner-icon="mdi-account"
              variant="outlined"
              :rules="[rules.required]"
              class="mb-4"
            ></v-text-field>

            <v-text-field
              v-model="username"
              label="Brugernavn"
              prepend-inner-icon="mdi-at"
              variant="outlined"
              :rules="[rules.required]"
              hint="Dette vil være dit unikke brugernavn"
              persistent-hint
              class="mb-4"
            ></v-text-field>

            <v-text-field
              v-model="email"
              :label="$t('auth.email')"
              type="email"
              prepend-inner-icon="mdi-email"
              variant="outlined"
              :rules="[rules.required, rules.email]"
              class="mb-4"
            ></v-text-field>

            <v-text-field
              v-model="password"
              :label="$t('auth.password')"
              :type="showPassword ? 'text' : 'password'"
              prepend-inner-icon="mdi-lock"
              :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append-inner="showPassword = !showPassword"
              variant="outlined"
              :rules="[rules.required, rules.minLength]"
              hint="Mindst 6 tegn"
              persistent-hint
              class="mb-4"
            ></v-text-field>

            <v-text-field
              v-model="confirmPassword"
              :label="$t('auth.confirmPassword')"
              :type="showConfirmPassword ? 'text' : 'password'"
              prepend-inner-icon="mdi-lock-check"
              :append-inner-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append-inner="showConfirmPassword = !showConfirmPassword"
              variant="outlined"
              :rules="[rules.required, rules.passwordMatch]"
              class="mb-6"
            ></v-text-field>

            <v-btn
              type="submit"
              color="primary"
              size="large"
              block
              :loading="loading"
              class="mb-4"
            >
              {{ $t('auth.createAccount') }}
            </v-btn>

            <v-divider class="my-6"></v-divider>

            <div class="text-center">
              <p class="text-body-2 mb-2">
                {{ $t('auth.alreadyHaveAccount') }}
              </p>
              <v-btn
                color="primary"
                variant="outlined"
                @click="$router.push('/login')"
              >
                {{ $t('nav.login') }}
              </v-btn>
            </div>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import api from '../services/api'

const router = useRouter()
const { t } = useI18n()

const formRef = ref(null)
const displayName = ref('')
const username = ref('')
const email = ref('')
const password = ref('')
const confirmPassword = ref('')
const showPassword = ref(false)
const showConfirmPassword = ref(false)
const loading = ref(false)
const errorMessage = ref('')
const successMessage = ref('')

const rules = {
  required: v => !!v || t('validation.required'),
  email: v => /.+@.+\..+/.test(v) || t('validation.email'),
  minLength: v => v.length >= 6 || 'Mindst 6 tegn',
  passwordMatch: v => v === password.value || t('validation.passwordMatch')
}

const handleRegister = async () => {
  const { valid } = await formRef.value.validate()
  if (!valid) return

  loading.value = true
  errorMessage.value = ''
  successMessage.value = ''

  try {
    const response = await api.post('/auth/register', {
      displayName: displayName.value,
      username: username.value,
      email: email.value,
      password: password.value
    })

    if (response.data.success) {
      successMessage.value = t('auth.registrationSuccess')
      
      // Redirect to login after 2 seconds
      setTimeout(() => {
        router.push('/login')
      }, 2000)
    }
  } catch (error) {
    errorMessage.value = error.response?.data?.message || t('auth.registrationFailed')
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.register-container {
  background: linear-gradient(135deg, #f5f5f5 0%, #e8f5e9 100%);
  min-height: 100vh;
}
</style>
